import styled from 'styled-components';
import tw from 'twin.macro';
import { Title } from '../../styled components/Typography';
import React from 'react';

export const WeekCounterText = styled(Title)(({ hidden, withActualHours }) => [
  hidden && tw`md:inline-block hidden`,
  withActualHours && tw`text-cyan-darken-10 ml-8`
]);
